/* global angular moment */
export default function() {
  return (date, range) => {
    const copyDate = angular.copy(date);

    if (new Date(copyDate).toString().toLowerCase() === 'invalid date') {
      return '';
    }

    const rangeDate = moment(date)
      .subtract(range, 'year')
      .add(1, 'day')
      .startOf('day')
      .format('LL');

    if (rangeDate.toLowerCase() === 'invalid date') {
      return '';
    }

    return rangeDate;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/PrettyDateOffset.js